module.exports = __webpack_public_path__ + "img/CarpalTunnel.0653f95c.svg";